export default "__VITE_ASSET__DpXfqTLM__"